import { useDebugValue } from 'react';
import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionValueFieldPath = () => {
  const conditionFieldPath = useConditionFieldPath();
  const fieldPath = `${conditionFieldPath}.value` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
